import { Link, useLocation, useNavigate } from 'react-router';
import { BackIcon } from './icons.js';

/** A direct link has no in-app history. Return to its containing page instead. */
export function parentScreen(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] === 'p' && parts[1]) {
    const project = `/p/${parts[1]}`;
    if (parts.length === 2) return '/projects';
    if (parts[2] === 'outputs' && parts.length > 3) return `${project}/outputs`;
    if (['state', 'memory', 'context'].includes(parts[2] ?? '')) return `${project}/knows`;
    return project;
  }
  if (parts[0] === 'projects' && parts.length > 1) return '/projects';
  if (['meet', 'room', 'r'].includes(parts[0] ?? '')) return '/meetings';
  if (parts[0] === 'parking-lot' && parts.length > 1) return '/parking-lot';
  return '/';
}

export function ScreenNavigation() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // React Router owns idx for this tab. Browser history.length includes other sites,
  // so it cannot establish that Back will remain in Jabberr.
  const index: unknown = window.history.state?.idx;
  const hasPrevious = typeof index === 'number' && index > 0;
  if (pathname === '/' && !hasPrevious) return null;
  return <nav className="screen-navigation" aria-label="Screen navigation">
    <button type="button" className="link-btn screen-back" onClick={() => {
      if (hasPrevious) void navigate(-1);
      else void navigate(parentScreen(pathname), { replace: true });
    }}><BackIcon size={18} /><span>Back</span></button>
    {pathname !== '/' && <Link to="/" className="screen-home">Home</Link>}
  </nav>;
}
